module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/uzemniPlanovani@2x-0a1f4f3d0d8fed6fac2645de9597e61f.png";